import React from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import "./index.scss";

export default function ChatImage({
  src,
  alt = "",
  loading = "lazy",
  variant = "inline",
  className,
  imgClassName,
  imageProps = {},
  as,
  ...rest
}) {
  if (!src) {
    return null;
  }

  const ComponentTag = as || (variant === "inline" ? "span" : "div");
  const rootClass = classNames("chat-image", `chat-image--${variant}`, className);
  const combinedImageProps = {
    src,
    alt,
    loading,
    className: classNames("chat-image__img", imgClassName),
    ...imageProps,
  };

  return (
    <ComponentTag className={rootClass} {...rest}>
      {/* eslint-disable-next-line jsx-a11y/alt-text */}
      <img {...combinedImageProps} />
    </ComponentTag>
  );
}

ChatImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  loading: PropTypes.oneOf(["lazy", "eager"]),
  variant: PropTypes.oneOf(["inline", "gallery"]),
  className: PropTypes.string,
  imgClassName: PropTypes.string,
  imageProps: PropTypes.object,
  as: PropTypes.elementType,
};
